import { z } from 'zod';
import { atLeastOneTrue } from '@/shared/validation/common.schemas';

/**
 * Send Notification Form Schema
 *
 * Validates bulk notification form for ADMIN users.
 * At least one receiver type must be selected.
 * Subject and content are required.
 */
export const sendNotificationSchema = z
  .object({
    // Receiver selection - at least one must be true
    sendToTeachers: z.boolean(),
    sendToPupils: z.boolean(),

    // Subject - required text field
    subject: z.string().min(1, 'Subiectul notificării este obligatoriu'),

    // Content - required markdown field
    content: z.string().min(1, 'Conținutul notificării este obligatoriu'),
  })
  .refine(atLeastOneTrue(['sendToTeachers', 'sendToPupils']), {
    message: 'Trebuie selectat cel puțin un tip de destinatar (profesori sau elevi)',
    path: ['sendToTeachers'], // Show error on first checkbox
  });

export type SendNotificationFormData = z.infer<typeof sendNotificationSchema>;
